import React from 'react';
import { createRoot } from 'react-dom/client';
import store from './app/store';
import { Provider } from 'react-redux';
import { OidcProvider } from 'redux-oidc';
import * as serviceWorker from './serviceWorker';
import { UserManager } from './app/utils';
import Routes from './app/routes';
import './index.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import App from './App';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';

const initialPath = window.location.pathname;
const lowerPath = initialPath.toLowerCase();

if (initialPath && initialPath !== '/' && !lowerPath.includes('login') && !lowerPath.includes('signin') && !lowerPath.includes('callback')) {
    const fullPath = initialPath + window.location.search;
    sessionStorage.setItem('EntryPathName', fullPath);
    window.name = 'ATEM_TARGET:' + fullPath;
}

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY);

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
   <Provider store={store}>
      <OidcProvider store={store} userManager={UserManager}>
        <Elements stripe={stripePromise}>
              <App />
        </Elements>
      </OidcProvider>
  </Provider>
);

serviceWorker.unregister();

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();